// extracted by mini-css-extract-plugin
export var wrapper = "SideBar-module--wrapper--3VBhj";
export var shop = "SideBar-module--shop--2AOQx";
export var image = "SideBar-module--image--1eouO";